import * as React from 'react';
import styled, { css } from 'styled-components';
import { rem } from 'polished';

// imported styled components
import { FlexRowCenter, FlexColCenter } from './Flexbox/Flexbox';
import { Icon } from './Defaults';

interface Props {
  label?: string;
  type?: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  name?: string;
  autoComplete?: string;
  disabled?: boolean;
  validationMessage?: string | null;
  inputStyle?: React.CSSProperties;
  className?: string;
  autofocus?: string;
  defaultValue?: string;
}

export class FormInputComponent extends React.Component<Props> {
  public static defaultProps: Partial<Props> = {
    disabled: false,
    validationMessage: null,
  };

  public shouldComponentUpdate(nextProps) {
    return (
      this.props.value !== nextProps.value ||
      this.props.validationMessage !== nextProps.validationMessage ||
      this.props.type !== nextProps.type
    );
  }

  public render() {
    const {
      label,
      type,
      placeholder,
      required,
      value,
      onChange,
      name,
      autoComplete,
      disabled,
      inputStyle,
      validationMessage,
      onBlur,
      className,
      autofocus,
      defaultValue,
    } = this.props;
    const valid: boolean = validationMessage === null;

    return (
      <Wrapper className={className} valid={valid}>
        {label && <InputLabel> {label} </InputLabel>}
        <FormInput
          onChange={onChange}
          onBlur={onBlur}
          type={type}
          placeholder={placeholder}
          required={required}
          value={value}
          name={name}
          autoComplete={autoComplete}
          disabled={disabled}
          style={inputStyle}
          valid={valid}
          autoFocus={autofocus}
          defaultValue={defaultValue}
        />
        <PopUpContainer valid={valid}>
          <PopUpValidationMessage>{validationMessage}</PopUpValidationMessage>
          <ArrowIcon>
            <Icon src={'/images/arrow_triangle.svg'} />
          </ArrowIcon>
        </PopUpContainer>
      </Wrapper>
    );
  }
}

const PopUpContainer: any = styled(FlexColCenter)`
  position: absolute;
  bottom: ${rem(34)};
  right: ${rem(15)};
  color: #fff;
  display: ${(props: any) => (props.valid ? 'none' : 'flex')};
`;

const PopUpValidationMessage = styled(FlexRowCenter)`
  width: 100%;
  min-height: ${rem(35)};
  padding: ${rem(6)} ${rem(11)};
  background: ${(props: any) => props.theme.colors.textPrimary};
  border-radius: ${rem(4)};
  font-size: ${rem(12)};
`;

const ArrowIcon = styled(FlexRowCenter)`
  width: ${rem(15)};
  height: ${rem(15)};
  position: relative;
  bottom: ${rem(5)};
`;

const Wrapper: any = styled.div`
  color: ${(props: any) => (props.valid ? '#aaaaaa' : '#ff0000')};
  position: relative;

  &:focus-within {
    color: ${(props: any) =>
      props.valid ? props.theme.colors.btnPrimary : '#ff0000'};
  }
`;

const InputLabel = styled.p`
  margin: 15px 0;
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-family: ${({ theme }) => theme.primaryFont};
  margin-bottom: 5px;
`;

const FormInput: any = styled.input`
  width: 100%;
  border-radius: ${({ theme }) => rem(theme.formElements.border.radius)};
  border: ${({ theme }) => rem(theme.formElements.border.width)} solid
    ${(props: any) =>
      props.valid ? props.theme.formElements.border.color : '#ff0000'};
  color: ${({ theme }) => theme.primaryFontColor};
  height: 50px;
  font-size: ${({ theme }) => theme.fontSizeS};
  color: ${props => props.theme.colors.textPrimary};
  padding-left: 15px;
  padding-right: 15px;

  ${(props: any) => {
    return (
      !props.valid &&
      css`
        box-shadow: 0 0 ${rem(8)} rgba(255, 0, 0, 0.5);
      `
    );
  }};

  &::placeholder {
    color: ${({ theme }) => theme.primaryFontColor};
    opacity: 0.4;
  }

  &:focus {
    outline: none !important;
    border-color: ${(props: any) =>
      props.valid ? props.theme.formElements.border.colorOnFocus : '#ff0000'};
    box-shadow: 0 0 ${rem(8)}
      ${(props: any) =>
        props.valid
          ? props.theme.formElements.border.colorOnFocus
          : 'rgba(255, 0, 0, 0.5)'};
  }
`;
